import { render, staticRenderFns } from "./SiteDetail.vue?vue&type=template&id=5a83df74&"
import script from "./SiteDetail.vue?vue&type=script&lang=js&"
export * from "./SiteDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports